export default "__VITE_ASSET__OxczvLNo__"